import React from "react";
import { Box } from "@mui/material";
import { classNames } from "../../models/models";

const DataBlocks = ({ children, className }: any) => {
  const styles = {
    background: "#FAFAFA",
    padding: "5px 10px",
  };

  return (
    <Box
      className={classNames("flex w-full justify-center gap-4", className)}
      sx={styles}
    >
      {children}
    </Box>
  );
};

export default DataBlocks;
